import { render, staticRenderFns } from "./screen_orden.vue?vue&type=template&id=2f02cc2c"
import script from "./screen_orden.vue?vue&type=script&lang=js"
export * from "./screen_orden.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports